import axios from 'axios';
import AppConfig from '../Constants/config';
import { utils } from './utils';
import Swal from 'sweetalert2';
import { reportError } from '../Services/PublicServices'

export const axioConfig = {
  configurateAxios: () => {
    // make a request recorder for error report
    let requestMap = new Map();

    // config request interceptor
    axios.interceptors.request.use(
      (config) => {
        
        const requestConfig = config;
        // Get the access token from locla storage
        const token = localStorage.getItem(AppConfig.ACCESS_TOKEN);
        const refreshToken = localStorage.getItem(AppConfig.REFRESH_TOKEN);
        // Add these headers for all requests
        requestConfig.headers['Content-Type'] = 'application/json';
        requestConfig.headers.common.Accept = 'application/json; charset=utf-8';
        // If the access token exists add it to the request headers
        if (token && !config.url.endsWith("RefreshToken")) {
          requestConfig.headers.Authorization = `Bearer ${token}`;
        } else if (config.url.endsWith("RefreshToken") && refreshToken) {
          requestConfig.headers.refresh_token = `${refreshToken}`;
        }

        // make a record for post request for the same url
        if(config.method === 'post'){
          let baseURL = config.baseURL;
          if(baseURL.endsWith('/')){
            baseURL = baseURL.substring(0, baseURL.length - 1);
          }
          let keyString = baseURL+config.url;
          //console.log(keyString);
          try {
            requestMap.set(keyString, JSON.stringify(config.data));
          } catch (error) {
            console.error("Unable to stringify request json data");
          }
          
          
        }
        return requestConfig;
      },
      error => Promise.reject(error),
    );

    // for multiple requests
    let isRefreshing = false;
    let failedQueue = [];
    const processQueue = (error, token = null) => {
      failedQueue.forEach((Promise) => {
        if (error) {
          Promise.reject(error);
        } else {
          Promise.resolve(token);
        }
      });
      failedQueue = [];
    };

    // configuration for automatic use refresh token

    axios.interceptors.response.use(
      (response)=>{
        if(requestMap.has(response.request.responseURL)){
          requestMap.delete(response.request.responseURL);
        }
        return response;
      },
      (error) => {
        let payloadJson = '';
        //console.log(error.request.responseURL);
        if(requestMap.has(error.request.responseURL)){
          payloadJson = requestMap.get(error.request.responseURL);
          requestMap.delete(error.request.responseURL);
        }
        const originalRequest = error.config;
        if (error && error.response && error.response.status === 401 && window.location.pathname !== '/login') {
          utils.removeInLocalStorage(AppConfig.ACCESS_TOKEN);
          utils.removeInLocalStorage(AppConfig.REFRESH_TOKEN);
          Swal.fire({
            icon: 'warning',
            title: 'Login Required',
            text: 'Your login do not have access to this resource or your login has expired. Please re-login and try again.',
            confirmButtonText: 'OK',
          }).then(() => {
            window.location.href = '/login';
          });
        }
        else if (error && error.response && error.response.status === 401 && window.location.pathname !== '/login' && !originalRequest._retry) {
          if (originalRequest.url.indexOf('/Login/RefreshToken') !== -1) {
            utils.removeInLocalStorage(AppConfig.ACCESS_TOKEN);
            utils.removeInLocalStorage(AppConfig.REFRESH_TOKEN);
            window.location.href = '/login';
          } else if (originalRequest.url.toLowerCase().indexOf('/login/login') === -1) {
            if (isRefreshing) {
              return new Promise(((resolve, reject) => {
                failedQueue.push({ resolve, reject });
              })).then((token) => {
                originalRequest.headers.Authorization = `Bearer ${token}`;
                return axios(originalRequest);
              }).catch(error => error);
            }
            originalRequest._retry = true;
            isRefreshing = true;
            // Get the refresh token from local storage
            const refreshToken = localStorage.getItem(AppConfig.REFRESH_TOKEN);
            return new Promise(((resolve, reject) => {
              axios.post('/Login/RefreshToken', { refreshToken: refreshToken })
                .then(({ status, data }) => {
                  if (status && status === 200) {
                    localStorage.setItem(AppConfig.ACCESS_TOKEN, data[AppConfig.ACCESS_TOKEN_PROP]);
                    localStorage.setItem(AppConfig.REFRESH_TOKEN, data[AppConfig.REFRESH_TOKEN_PROP]);
                    //axios.defaults.headers.common.Authorization = `Bearer ${res.data[AppConfig.ACCESS_TOKEN_PROP]}`;
                    //originalRequest.headers.Authorization = `Bearer ${res.data[AppConfig.ACCESS_TOKEN_PROP]}`;
                    processQueue(null, data[AppConfig.ACCESS_TOKEN_PROP]);
                    resolve(axios(originalRequest));
                  } else {
                    window.location = '/login';
                  }
                })
                .catch((error) => {
                  processQueue(error, null);
                  reject(error);
                })
                .then(() => { isRefreshing = false; });
            }));
          }
        } else if (error && error.response && (error.response.status === 500 || error.response.status === 400 || error.response.status === 405)
          && !error.request.responseURL.toLowerCase().endsWith('reporterror')
        ) {
          // Handle 500 on gloable level
          let message = "An unexpected error has occurred. Technical support has been notified. Please try again later.";
          Swal.fire({
            icon: 'error',
            position: 'top-end',
            title: 'Internal Server Error',
            text: message,
            timer: 10000,
            toast: true,
            timerProgressBar: true,
            showConfirmButton: false,
            showCancelButton: false,
            footer: 'If issue remains, please contact DDS office.'
          })
          
          let errorReportPayload = {
            errorCode: error.response.status.toString(),
            errorRequestURL: error.request.responseURL,
            errorPayloadJSON: payloadJson,
          };
          // sendout error report when render process is not that busy.
          setTimeout(() => {
            reportError(errorReportPayload);
          }, 0);

        }
        return Promise.reject(error);
      },
    );
  }
}
